// Helpers to constrain manual typing in react-datepicker inputs.
//
// react-datepicker lets users type freely into the text input, which means a
// `dd/MM/yyyy` field will happily accept "03/06/202600000" (year > 4 digits)
// until it is parsed on blur. These helpers cap the raw input length and strip
// characters that can never appear in the date format, so the field can never
// hold an out-of-range / overlong value.

// Length of the formatted date string for a given dateFormat (e.g.
// "dd/MM/yyyy" -> 10). Falls back to the format string's own length.
export const dateFormatMaxLength = (dateFormat = "dd/MM/yyyy") => dateFormat.length;

// onChangeRaw handler factory for a DatePicker using a slash/dash numeric
// format such as "dd/MM/yyyy". Truncates anything typed beyond the format
// length and removes characters other than digits and the separators, so the
// year (or any other part) can never exceed its allowed digit count.
export const handleDatePickerRawChange = (dateFormat = "dd/MM/yyyy") => (event) => {
  const input = event?.target;
  if (!input || typeof input.value !== "string") return;

  const maxLen = dateFormatMaxLength(dateFormat);
  // Keep only digits and the format's separators (/ . -).
  const cleaned = input.value.replace(/[^\d/.-]/g, "");
  const clamped = cleaned.slice(0, maxLen);

  if (clamped !== input.value) {
    input.value = clamped;
  }
};
